import React from "react";

/**
 * Identical to useState, but also updates the state when the value changes
 **/
export const useDependentState = <T>(value: T) => {
  const [state, setState] = React.useState(value);

  React.useEffect(() => {
    setState(value);
  }, [value]);

  return [state, setState] as const;
};
